/* eslint-disable camelcase */

/**
 * Script params for woocommerce-js
 * 
 * @typedef {Object} WooCommerceParams
 * @property {string} wc_ajax_url
 */

import $ from '@/js/front/jquery';

/** @param {WooCommerceParams} window.woocommerce_params */

/**
 * Get the WooCommerce AJAX URL for and endpoint.
 * @param endpoint
 * @returns {string | undefined}
 */
const getWooCommerceAjaxUrl = ( endpoint ) => {
	return window.woocommerce_params.wc_ajax_url?.replace( '%%endpoint%%', endpoint );
};

/**
 * Update the notices wrapper with new notices.
 * @param {string} noticesHtml
 */
const updateNotices = ( noticesHtml ) => {
	const wrapperElement = document.querySelector( '.woocommerce-notices-wrapper' );

	if ( wrapperElement ) {
		wrapperElement.innerHTML += noticesHtml;
	}
};

/**
 * Add an item to the cart.
 * @param {HTMLButtonElement} button
 * @param {HTMLFormElement}   form
 * @return {void}
 */
const addToCart = ( button, form ) => {
	const data = new FormData( form );

	if ( button.name ) {
		data.append( button.name, button.value );
	}

	button.classList.remove( 'added' );
	button.classList.add( 'loading' );

	$( document.body ).trigger( 'adding_to_cart', [ $( button ), data ] );
	
	fetch( getWooCommerceAjaxUrl( 'avenla_add_to_cart' ), {
		method: 'POST',
		body: data,
	} ).then( ( response ) => response.json() )
		.then( ( result ) => {
			/**
			 * Triggers WooCommerce's own fragment update.
			 * @see AddToCartHandler.updateFragments
			 */
			$( document.body ).trigger( 'added_to_cart', [ result.fragments, result.cart_hash, $( button ) ] );
			
			button.classList.add( 'added' );
			button.classList.remove( 'loading' );

			openSideCart();

			if ( 'notices' in result ) {
				updateNotices( result.notices );
			}
		} );
};

/**
 * Open the side cart / mini cart.
 */
const openSideCart = () => {
	document.querySelector( '[data-open="#cart-popup"]' )?.click();
};

export { addToCart, openSideCart };
